"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplicaAdGroupReportSummaryQuerySchema = exports.ReplicaAdGroupReportGroupingQuerySchema = exports.ListReplicaAdGroupReportsResponseSchema = exports.ListReplicaAdGroupReportsQuerySchema = exports.UpdateReplicaAdGroupReportsBodySchema = exports.UpdateReplicaAdGroupReportSchema = exports.ReplicaAdGroupReportSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const common_1 = require("./common");
const reports_1 = require("./reports");
exports.ReplicaAdGroupReportSchema = (0, core_1.StrictObject)({
    ...common_1.ReplicaReportMetadataFields,
    ...reports_1.ReplicaReportFields,
    adGroupRef: ruby_1.AppleProxyRefSchema,
    purpose: typebox_1.Type.Optional(ruby_1.PurposeSchema),
});
exports.UpdateReplicaAdGroupReportSchema = typebox_1.Type.Object({
    ...reports_1.ReplicaReportFields,
    adGroupRef: ruby_1.AppleProxyRefSchema,
});
exports.UpdateReplicaAdGroupReportsBodySchema = typebox_1.Type.Object({
    ...common_1.ReplicaReportMetadataFields,
    reports: typebox_1.Type.Array(exports.UpdateReplicaAdGroupReportSchema),
});
exports.ListReplicaAdGroupReportsQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    ...common_1.ReplicaReportMetadataQueryFields,
    adGroupRef: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.AppleProxyRefSchema)),
    purpose: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.PurposeSchema)),
});
exports.ListReplicaAdGroupReportsResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.ReplicaAdGroupReportSchema);
const GroupingBySchema = (0, core_1.StringUnion)([
    "campaignId",
    "period",
    "country",
    "campaignRef",
    "adGroupRef",
    "purpose",
]);
exports.ReplicaAdGroupReportGroupingQuerySchema = (0, core_1.StrictObject)({
    ...common_1.ReplicaReportMetadataQueryFields,
    by: GroupingBySchema,
    adGroupRef: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.AppleProxyRefSchema)),
    purpose: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.PurposeSchema)),
});
exports.ReplicaAdGroupReportSummaryQuerySchema = (0, core_1.StrictObject)({
    ...common_1.ReplicaReportMetadataQueryFields,
    adGroupRef: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.AppleProxyRefSchema)),
    purpose: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.PurposeSchema)),
});
